module.exports = __webpack_public_path__ + "img/product.8a52e4a6.svg";